/// <amd-module name="Search/Code/Flux/Stores/PreviewStore" />
import * as VSSStore from "VSS/Reflux/Store";
import { PrivewPivotActionIds } from "Search/Code/Constants";
import { IActiveTabChangedPayload } from "Search/Code/Flux/ActionsHub";

export interface IPreviewStoreState {
    activeTabKey: string | undefined;

    isFullScreen: boolean;
}

export class PreviewStore extends VSSStore.Store {
    private _state: IPreviewStoreState = { isFullScreen: false, activeTabKey: undefined };
    constructor(changeEventName: string, isFullScreen: boolean) {
        super(changeEventName);
        this._state.isFullScreen = isFullScreen;
    }

    public get state(): IPreviewStoreState {
        return this._state;
    }

    public initActiveTab = (tabKey: string | undefined): void => {
        this._state.activeTabKey = tabKey || PrivewPivotActionIds.Contents;
        this.emitChanged();
    }

    public changeActiveTab = (payload: IActiveTabChangedPayload): void => {
        this._state.activeTabKey = payload.activeTabKey;
        this.emitChanged();
    }

    public toggleFullScreen = (isFullScreen: boolean): void => {
        this._state.isFullScreen = isFullScreen;
        this.emitChanged();
    }
}